// DOCUMENTS ACTIONS
export const GET_DOCUMENTS = 'GET_DOCUMENTS';
export const SET_DOCUMENTS_FILTERED = 'SET_DOCUMENTS_FILTERED';
export const SET_MESSAGE = 'SET_MESSAGE';
export const SET_ERROR = 'SET_ERROR';
export const SET_PANEL_IS_OPEN = 'SET_PANEL_IS_OPEN';
export const SET_FILTERS_IS_OPEN = 'SET_FILTERS_IS_OPEN';
